import { withVersion } from 'api/utils/withVersion';
export var getFeatureFlagsPath = function getFeatureFlagsPath() {
    return withVersion.v1('/enabled-features');
};
